import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQ_CATEGORIES } from "@/constants/business";

export default function FAQSection() {
  return (
    <section id="faq" data-testid="faq-section" className="py-14 md:py-20 px-4 md:px-8 max-w-4xl mx-auto">
      <div className="mb-10">
        <span className="text-xs uppercase tracking-[0.2em] font-bold text-orange">Questions fréquentes</span>
        <h2 className="font-heading font-bold text-3xl md:text-4xl tracking-tight text-navy mt-3">FAQ</h2>
      </div>

      <div className="space-y-10">
        {FAQ_CATEGORIES.map((category) => (
          <div key={category.key} data-testid={`faq-category-${category.key}`}>
            <h3 className="font-heading font-semibold text-lg text-navy mb-4">{category.label}</h3>
            <Accordion type="single" collapsible className="space-y-3">
              {category.items.map((item, i) => (
                <AccordionItem
                  key={item.q}
                  value={`${category.key}-${i}`}
                  data-testid={`faq-item-${category.key}-${i}`}
                  className="bg-white border border-gray-200 rounded-2xl px-5"
                >
                  <AccordionTrigger data-testid={`faq-trigger-${category.key}-${i}`} className="text-left font-heading font-semibold text-navy text-base hover:no-underline">
                    {item.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-muted-foreground text-sm leading-relaxed">{item.a}</AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        ))}
      </div>
    </section>
  );
}
